/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/user';
import { USER } from '@/store/types';
import { UserVerify } from '@/api/types/user';

export interface StoreUserVerifyListState {
  filter: string;
  list: UserVerify[];
  point: number;
  count: number;
  lock: boolean;
  noMore: boolean;
}

export default {
  namespaced: true,
  state: {
    filter: null,
    list: [],
    point: null,
    count: null,
    lock: false,
    noMore: false,
  },
  getters: {},
  actions: {
    [USER.GET_VERIFIED_INFO_LIST]({ state, commit }, { filter, more, reload }) {
      if (state.filter !== filter) {
        reload = true;
      }
      const point = reload ? null : state.point;
      if (reload || more) {
        commit(USER.GET_VERIFIED_INFO_LIST, {
          status: 'start',
        });
        return new Promise((resolve, reject) => {
          api.getVerifiedInfoList(filter, point).then((res) => {
            commit(USER.GET_VERIFIED_INFO_LIST, {
              status: 'success',
              point,
              filter,
              list: res.data,
              count: res.extra.count,
            });
            resolve();
          }).catch(() => {
            commit(USER.GET_VERIFIED_INFO_LIST, {
              status: 'error',
            });
            reject();
          });
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [USER.GET_VERIFIED_INFO_LIST](state, { status, point, filter, list, count }) {
      if (status === 'start') {
        state.lock = true;
      } else {
        if (status === 'success') {
          if (state.point !== point || state.filter !== filter) {
            state.list = [];
            state.point = null;
            state.filter = filter;
          }
          if (list.length) {
            state.point = list[list.length - 1].id;
          }
          state.list = state.list.concat(list);
          state.count = count;
          state.noMore = state.list.length === state.count;
        }
        state.lock = false;
      }
    },
    [USER.PUT_VERIFIED_INFO](state, id) {
      if (state.filter === 'pending') {
        state.list = state.list.filter(p => p.id !== id);
      }
    },
  },
};
